module.exports = "./img/cc3f215841e14f2a3b549307aadd44e0.jpg";